module.exports = __webpack_public_path__ + "static/media/72_zinc_metal_seamless.d789bb52.jpg";